export enum ModelFilterNames {
  EnginePower = 'EnginePower',
  Gear = 'Gear',
  Engine_2 = 'Engine_2',
  EngineTypeAttribute2 = 'EngineTypeAttribute2',
  FuelType = 'FuelType',
  EquipmentLine = 'EquipmentLine',
}

export const EngineModelFilterNames = [
  ModelFilterNames.EnginePower,
  ModelFilterNames.Engine_2,
  ModelFilterNames.EngineTypeAttribute2,
  ModelFilterNames.FuelType,
];
